var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.33,
    height: 16.25,
    viewBox: "0 0 15.33 16.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-7.001 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17097",
    "data-name": "Group 17097",
    transform: "translate(7.001 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38263",
    "data-name": "Path 38263",
    d: "M22.2,8.1a3.067,3.067,0,0,0-3.063-2.874h-.789V4.613a.613.613,0,0,0-1.226,0v.613H12.213V4.613a.613.613,0,1,0-1.226,0v.613H10.2A3.067,3.067,0,0,0,7.135,8.1a75.2,75.2,0,0,0,.01,9.137,3.07,3.07,0,0,0,2.869,2.869c1.543.1,3.1.144,4.652.144s3.109-.048,4.652-.144a3.07,3.07,0,0,0,2.869-2.869A75.2,75.2,0,0,0,22.2,8.1Zm-1.234,9.061a1.842,1.842,0,0,1-1.721,1.721,74.091,74.091,0,0,1-9.151,0A1.842,1.842,0,0,1,8.37,17.161c-.145-2.331-.175-4.687-.1-7.029H21.061C21.138,12.475,21.108,14.831,20.963,17.161ZM11.6,7.679a.613.613,0,0,0,.613-.613V6.453h4.906v.613a.613.613,0,1,0,1.226,0V6.453h.789a1.839,1.839,0,0,1,1.838,1.72c.014.243.021.488.032.733H8.327c.012-.244.018-.489.033-.733A1.839,1.839,0,0,1,10.2,6.453h.789v.613a.613.613,0,0,0,.613.613Z",
    transform: "translate(-7.001 -4)",
    fill: "#898d93"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2767",
    "data-name": "Ellipse 2767",
    cx: 1.103,
    cy: 1.103,
    r: 1.103,
    transform: "translate(3.309 7.721)",
    fill: "#898d93"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2768",
    "data-name": "Ellipse 2768",
    cx: 1.103,
    cy: 1.103,
    r: 1.103,
    transform: "translate(6.618 7.721)",
    fill: "#898d93"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2769",
    "data-name": "Ellipse 2769",
    cx: 1.103,
    cy: 1.103,
    r: 1.103,
    transform: "translate(3.309 11.03)",
    fill: "#898d93"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2770",
    "data-name": "Ellipse 2770",
    cx: 1.103,
    cy: 1.103,
    r: 1.103,
    transform: "translate(9.927 7.721)",
    fill: "#898d93"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2771",
    "data-name": "Ellipse 2771",
    cx: 1.103,
    cy: 1.103,
    r: 1.103,
    transform: "translate(9.927 11.03)",
    fill: "#898d93"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2772",
    "data-name": "Ellipse 2772",
    cx: 1.103,
    cy: 1.103,
    r: 1.103,
    transform: "translate(6.618 11.03)",
    fill: "#898d93"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1f7bd473.svg";
export { ForwardRef as ReactComponent };